import { dateDurations } from '../constants/dateDurations';
import { getDateDisplayHint, getPropertyType } from './propertyGetters';
import { DATE, DATE_TIME } from '../constants/property-types';
//@ts-expect-error Untyped import
import getProperties from '../properties/index';
import { Set as ImmutableSet } from 'immutable';
export const isDateOrDateTime = property => {
  const propertyType = getPropertyType(property);
  return [DATE, DATE_TIME].includes(propertyType);
};
export const isDurationDateProperty = property => {
  if (!isDateOrDateTime(property)) {
    return false;
  }
  const dateDisplayHint = getDateDisplayHint(property) || '';
  return dateDurations.includes(dateDisplayHint);
};
export const getHiddenProperties = dataType => dataType ? getProperties(dataType).then(propertyMetadata => propertyMetadata.get(dataType).filter(prop => prop === null || prop === void 0 ? void 0 : prop.get('hidden')).map(prop => prop === null || prop === void 0 ? void 0 : prop.get('name')).toSet()) : Promise.resolve(ImmutableSet());